import { render } from "./uploading.vue?vue&type=template&id=63c4e360"
import script from "./uploading.vue?vue&type=script&lang=js"
export * from "./uploading.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__